import React from 'react'
import Layout from '../elements/Layout'

const Bookings = () => {
  return (
    <Layout>Bookings</Layout>
  )
}

export default Bookings